export const USER = 'STORAGE/USER'
